import { Injectable } from "@angular/core";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { RegistrationResponse } from "../registration.model";

import {
	GetSPIDJwtTokenPayload,
	GetSPIDAuthorizationUrlPayload,
	SPIDRegistrationPayload,
} from "./registration-with-spid.model";

export const ACTION_PREFIX = "[Registration With SPID]";

export const REGISTRATION_WITH_SPID_ID_ACTION_TYPE = {
	getSPIDAuthorizationUrl: `${ACTION_PREFIX} Get SPID Registration URL`,
	getSPIDAuthorizationUrlSuccess: `${ACTION_PREFIX} Get SPID Registration URL Success`,
	getSPIDAuthorizationUrlFail: `${ACTION_PREFIX} Get SPID Registration URL Fail`,

	getSPIDJwtToken: `${ACTION_PREFIX} Get SPID JWT Token`,
	getSPIDJwtTokenSuccess: `${ACTION_PREFIX} Get SPID JWT Token Success`,
	getSPIDJwtTokenFail: `${ACTION_PREFIX} Get SPID JWT Token Fail`,

	getRegistrationToken: `${ACTION_PREFIX} SPID Get Registration Token`,
	getRegistrationTokenSuccess: `${ACTION_PREFIX} SPID Get Registration Token Success`,
	getRegistrationTokenFail: `${ACTION_PREFIX} SPID Get Registration Token Fail`,

	setRegistrationDetails: `${ACTION_PREFIX} Set Registration Form Data ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class RegistrationWithSPIDAction {
	getSPIDAuthorizationUrl(payload: GetSPIDAuthorizationUrlPayload = { flowType: "registration" }): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrl,
			payload,
		};
	}

	getSPIDAuthorizationUrlSuccess(payload: string): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrlSuccess,
			payload,
		};
	}

	getSPIDAuthorizationUrlFail(payload: AppError): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrlFail,
			payload,
		};
	}

	getSPIDJwtToken(payload: GetSPIDJwtTokenPayload): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtToken,
			payload,
		};
	}

	getSPIDJwtTokenSuccess(payload: string): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtTokenSuccess,
			payload,
		};
	}

	getSPIDJwtTokenFail(payload: AppError): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtTokenFail,
			payload,
		};
	}

	getRegistrationToken(payload: SPIDRegistrationPayload): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationToken,
			payload,
		};
	}

	getRegistrationTokenSuccess(payload: RegistrationResponse): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationTokenSuccess,
			payload,
		};
	}

	getRegistrationTokenFail(payload: AppError): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationTokenFail,
			payload,
		};
	}

	setRegistrationDetails(payload: SPIDRegistrationPayload): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SPID_ID_ACTION_TYPE.setRegistrationDetails,
			payload,
		};
	}
}
